import { createGameSound } from './188-game-sound.mjs';
import { attachCreativeFeedback } from './54-creative-feedback.mjs';
import { createMarblePresentation } from './180-marble-presentation.mjs';
import { createClusterPresentation } from './183-cluster-presentation.mjs';
import { createScoreArcadePresentation } from './189-score-arcade.mjs';
import { createCraftPresentation } from './191-craft-arcade.mjs';

/** Compose optional per-game presentations around one canonical card state.
 * State, history, permissions and moves remain owned by the card controller;
 * each presentation releases its own listeners, hints, sound and decoration. */
export function createBoardDecorations(ctx, options) {
  const { game, board, scene, allowed, canInspect } = options;
  const creative = attachCreativeFeedback(ctx, board, scene);
  const puzzles = createScoreArcadePresentation(ctx, { ...options, enabled: canInspect });
  const craft = ['pebble-balance', 'flow-paths'].includes(game.id)
    ? createCraftPresentation(ctx, { ...options, allowed: canInspect })
    : null;
  const sound = !['cluster-pop', 'ball-sort'].includes(game.id)
    ? createGameSound(ctx, { ...options, enabled: canInspect })
    : null;
  const creativeFeedback = {
    play(previous, state, flight) {
      creative.play(previous, state);
      sound?.accepted(previous, state);
      puzzles?.accepted(previous, state);
      craft?.accepted(previous, state, flight);
    },
    cancel() {
      creative.cancel();
      sound?.stop();
      puzzles?.cancel();
      craft?.cancel();
    },
    dispose() {
      creative.dispose();
      sound?.dispose();
      puzzles?.dispose();
      craft?.dispose();
    },
  };
  const marbles =
    game.id === 'ball-sort' ? createMarblePresentation(ctx, { ...options, allowed }) : null;
  const bubbles =
    game.id === 'cluster-pop'
      ? createClusterPresentation(ctx, { ...options, enabled: canInspect })
      : null;
  return { creativeFeedback, marbles, bubbles, puzzles, craft };
}
